// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"form_checkbox__M5M6P","checkbox__checked":"form_checkbox__checked__QJhGV"};